import requestV2 from '@/utils/requestV2'
const qs = require('qs')

// 获取公司配置
export function getCompanySetting (data) {
  return requestV2({
    url: '/ooh-os/v1/company/getcompanysetting',
    method: 'post',
    data: qs.stringify(data)
  })
}
